import { api } from './client';

export const levelUpgradeAPI = {
  rpApOrbPreview: (target_level: string) =>
    api.get<Record<string, unknown>>('/api/level-upgrade/rp-ap-orb/preview', {
      target_level,
    }),

  rpApOrbExecute: (body: {
    target_level: string;
    transaction_password: string;
    security_answer: string;
    memo?: string;
    idempotency_key?: string;
  }) => api.post<Record<string, unknown>>('/api/level-upgrade/rp-ap-orb/execute', body),
};
